import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
export const columnHeadings = [
  { title: "Name", id: "full_name" },
  { title: "Plan Type", id: "plan_" },
  {
    title: "Email",
    id: "email",
  },
  { title: "Amount  ", id: "transaction_amount" },
  { title: "Level", id: "" },
  { title: "Coins", id: "coins" },
  {
    title: "Transaction Type",
    id: "transaction_type",
  },
  { title: "Payment Date", id: "date" },
  { title: "Status", id: "status" },
  {
    title: "Actions",
    id: "actions",
  },
];

// Only the fields the plan payments API returns; approved payments have no actions.
export const planPaymentColumnHeadings = [
  { title: "Transaction ID", id: "transaction_id" },
  { title: "Name", id: "name" },
  { title: "Email", id: "email" },
  { title: "Plan Type", id: "plan" },
  { title: "Amount", id: "price" },
  { title: "Level", id: "level" },
  { title: "Coins", id: "coins" },
  { title: "Payment Method", id: "payment_method" },
  { title: "Payment Date", id: "paid_on" },
];

// Values the plan payments API filters payment_method by.
export const planPaymentMethods = [
  { label: "All Methods", value: "" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "JazzCash", value: "jazz_cash" },
  { label: "In-App Google", value: "google" },
  { label: "In-App Apple", value: "apple" },
];

export const emptyPlanPaymentFilters = {
  date_from: "",
  date_to: "",
  payment_method: "",
};

// Only the fields the refunded plan payments API returns; refunds have no actions.
export const refundColumnHeadings = [
  { title: "Transaction ID", id: "transaction_id" },
  { title: "Username", id: "username" },
  { title: "Email", id: "email" },
  { title: "Plan Type", id: "plan" },
  { title: "Amount", id: "price" },
  { title: "Level", id: "level" },
  { title: "Coins", id: "coins" },
  { title: "Payment Date", id: "paid_on" },
  { title: "Refund Date", id: "refunded_at" },
];

export const headings = {
  mainHeading: "Approved Subscriptions History",
  subHeading: "Manage all approved subscriptions from here",
};

export const transactionTypes = [
  {
    id: 1,
    name: "Online",
  },
  {
    id: 2,
    name: "Manual",
  },
];

export const actions = [
  {
    id: "view",
    text: "View",
    icon: <RemoveRedEyeIcon />,
  },
];

export const skeletonInfo = {
  rows: 8,
  cellCount: 9,
  actions: 1,
  showPerson: false,
};
